/**
 * 빈 유료 광고 자리 «오픈 기념 +1주 무료» 쿠폰 배너(E안) — 순수 상수·문구(DB·서버 import 0 · 클라이언트 번들 안전).
 *  켜는 조건: app_config ads.promo_bonus.enabled === true(promo.ts parsePromoBonus) — 서버가 정해 prop 으로 내린다.
 *  ⛔ 카더라 자체 홍보 배너는 «양보하지 않는다»(Node 10/30·10/31): 자리가 비든 유료 광고가 차든·무료 연장일이든·판매 불가 현장이든
 *     모든 광고 자리에 유료 광고와 «나란히» 늘 보인다. 스위치(promo_bonus.enabled)가 꺼질 때만 종전 빈 자리 안내.
 *  세 자리: 홈 «분양 광고» 모집 칸(16:9) · 현장 상세 빈 현장 광고 줄(3:1) · 시군구 배너 빈 자리(3:1).
 *  ⛔ 마감·한정 같은 재촉 표현 없음 · 금액 없음(«추가 비용 0원» 만).
 */
export const PROMO_SLOT_ALT = '카더라 분양광고 오픈 기념 — 광고 기간 +1주 무료(추가 비용 0원)';

/** 이미지(그림 안에 문구가 들어 있다) — webp 우선 · jpg 대체. 고유 크기를 넘겨 비율 상자를 미리 잡는다(CLS 0). */
export const PROMO_IMG = {
  wide169: { webp: '/ads/promo/e_16x9.webp', jpg: '/ads/promo/e_16x9.jpg', width: 1600, height: 900 },
  banner31: { webp: '/ads/promo/e_3x1.webp', jpg: '/ads/promo/e_3x1.jpg', width: 1800, height: 600 },
} as const;
export type PromoImgKind = keyof typeof PROMO_IMG;

export type PromoSlotFrom = 'promo_home' | 'promo_site' | 'promo_district';
/** 광고 안내 페이지(/advertise) — 출처만 붙인다(계측 advertise_click 의 category 와 같은 값). */
export const promoSlotHref = (from: PromoSlotFrom): string => `/advertise?from=${from}`;

/** 홈 «분양 광고» 모집 칸 문구 */
export const PROMO_HOME_COPY = {
  tag: '카더라 안내',
  meta: '카더라 분양광고 · 오픈 기념',
  head: '광고 기간 +1주 무료 — 이 자리에 현장을 알리세요',
  desc: '2주 결제하면 3주, 4주 결제하면 5주 게재 · 추가 비용 0원',
  chip: '홈 배너',
  cta: '광고 안내 보기 →',
} as const;

/** 시군구 배너 빈 자리 문구(유료 시군구 배너와 같은 틀) */
export const PROMO_DISTRICT_COPY = {
  name: '분양 현장',
  chip: '카더라 안내',
  head: '1주 무료 연장',
  intro: '추가 비용 0원',
  cta: '광고 안내 보기 →',
} as const;

/** 현장 상세 빈 현장 광고 줄 위 작은 글 */
export const PROMO_SITE_CAPTION = '카더라 안내 · 이 현장 광고 자리';
/** 현장 광고 자리가 찼을 때(유료 게재·예약) 쿠폰 배너 위 작은 글 — 자리가 찼으니 «이 현장 광고 자리» 없음 */
export const PROMO_SITE_CAPTION_TAKEN = '카더라 안내';
